import styled                 from 'styled-components';

import { TypographyVariants } from 'src/components/common/typography';
import { LinkVariants       } from 'src/components/common/link';

import { cssFlexColumn,
         themeColors        } from 'src/providers/theme/shared';



type NoteLookAndFeel = {
  paddings: number[];
  borderColor: string;
  topograhyVariant: TypographyVariants;
  linkVariant: LinkVariants;
}

const note_light: NoteLookAndFeel = {
  paddings: [20],
  borderColor: themeColors.BorderSecondary,
  topograhyVariant: 'blackw400s12lh14',
  linkVariant: 'blue14',
}

export type NoteVariants = 'light';

export const note_variants: Map<NoteVariants, NoteLookAndFeel> = 
  new Map<NoteVariants, NoteLookAndFeel>([
    ['light', note_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: NoteLookAndFeel;
}>`
  ${cssFlexColumn}
  width: 100%;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px;
  text-align: left;

  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: 12px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
`
